import { testimonials, valueProps } from "@/mocks/guatian";

export default function About() {
  return (
    <section id="about" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-background-200 px-3 py-1.5 text-xs font-bold text-foreground-600">
              <i className="ri-building-2-line" aria-hidden="true"></i>
              关于我们 ABOUT
            </div>
            <h2 className="mt-3 text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              我们不做标题党，<br />只做让信息<span className="text-primary-600">归位的人</span>
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              大雷网站成立于对「真相散落在零散片段里」的焦虑。当一条热点在 24 小时内被反复改写，围观者最需要的不是更多情绪，而是一份能把先后顺序、来源与状态讲清楚的时间线。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              因此我们把每条热点都拆成「后续进展、最新反转、事件更新、瓜田动态」四个抽屉，让信息按发生顺序各归其位。我们不替你下结论，只负责把事实摆整齐，把「待证实」三个字标得足够醒目。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-3">
              {valueProps.map((v) => (
                <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-lg text-background-50">
                    <i className={v.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-900">{v.title}</h3>
                  <p className="mt-1.5 text-xs leading-5 text-foreground-500">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2">
              <i className="ri-chat-heart-line text-xl text-accent-500" aria-hidden="true"></i>
              <h3 className="text-lg font-bold text-foreground-950">他们这么说</h3>
              <span className="text-xs text-foreground-400">站内读者真实反馈</span>
            </div>
            <div className="mt-4 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-1 text-sm text-secondary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-6 text-foreground-700">“{t.text}”</blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-sm font-bold text-primary-700">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}